<div class="card">
  <div class="card-header card-header-dark d-flex">
    <span class="mr-2">{{'STARTED_ALERTS' |translate}}</span>
    <app-notification-badge
      [count]="alerts.length"
      [warningStatus]="false"
      style="margin-top: 3px;"
    ></app-notification-badge>
  </div>
  <div
    class="card-body card-body-dark"
    cdkDropList
    id="startedAlertList"
    [cdkDropListData]="alerts"
    [cdkDropListConnectedTo]="['incomingAlertList', 'forwardedAlertList']"
    (cdkDropListDropped)="crService.drop($event)"
  >
    @for (alert of alerts; track alert.alertId) {
    <div
      cdkDrag
      [cdkDragDisabled]="!alert.allowTransition"
    >
      <!--Alert card-->
      @if (crService.alertIsNightowlVisit(alert)) {
      <span
        [ngTemplateOutlet]="visitTemplate"
        [ngTemplateOutletContext]="{
            data: alert,
            src: alert.cameraVisitURL
            }"
      ></span>
      }
      @if (!crService.alertIsNightowlVisit(alert)) {
      <div class="alertCard">
        <div
          class="alertCardHeader"
          [ngClass]="{'alertCardHeaderWithDrag': alert.allowTransition, 'alertCardTransitional': alert.transitional}"
          cdkDragHandle
        >
          <div class="row">
            <div class="col-12 clearfix">
              <div class="float-left mr-3">
                @if (alert.iconResponse) {
                <i
                  class="fa-3x {{alert.iconResponse?.iconClass}}"
                  [style.color]="alert.iconResponse?.color || ''"
                ></i>
                }
              </div>
              <div class="alarmCardHeaderInfo">
                <div class="mr-3">
                  <div class="alarmSourceInfo">
                    <p class="alertHeader">
                      <strong class="text-nowrap">{{alert.header}} ({{alert.productId}})</strong>
                    </p>
                    @if (alert.increment > 0) {
                    <div
                      class="cursorPointer ml-2"
                      (click)="crSync.resetAlertIncrement(alert.userId, alert.alertId)"
                      matTooltip="{{'INCREMENT_INFO' |translate}} {{'CLICK_TO_RESET' |translate}}"
                      [matTooltipPosition]="'above'"
                    >
                      <span class="badge badge-pill badge-danger">{{'+' + alert.increment}}</span>
                    </div>
                    }
                  </div>
                  <p class="alertHeader"> {{ alert | pickUpActivationName }}</p>
                  <small>{{ alert.time | calculateAlertTime }}</small>
                </div>
                <div class="cancelResBtnContainer">
                  <button
                    class="btn btn-outline-primary cursorPointerHover float-right"
                    style="text-wrap: nowrap;"
                    (click)="cancelReservation(alert)"
                  >
                    <span class="fa-light fa-fw fa-reply"></span>&nbsp;&nbsp;{{'CANCEL_RESERVATION'
                    |translate}}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <app-customer-rules
          [customerId]="alert.customerId"
          [serverId]="alert.alertId"
        ></app-customer-rules>
        @for (camera of alert.cameraVisitURLArray; track camera.id) {
        <div
          (mouseenter)="activateIframeClick(camera.id || alert.alertId)"
          style="position:relative;"
        >
          <iframe
            allowfullscreen
            [src]="camera.videoUrl | safe"
            [style.pointer-events]="iFrameClicked === (camera.id || alert.alertId) ? 'auto' : 'none'"
            class="started"
            title="Camera visit"
            allow="autoplay; microphone; fullscreen"
          ></iframe>
        </div>
        }
        <app-alarm-history
          [deviceId]="alert.productId"
          [customerId]="alert.customerId"
        >
        </app-alarm-history>
        <div class="alertCardBody">
          <div class="mt-3">
            <p class="mt-2">
              <span class="fa-light fa-lg fa-fw fa-location-dot"></span>&nbsp;&nbsp;{{alert.address}}
            </p>
          </div>
          @if (alert.place) {
          <div class="mt-3">
            <p class="mt-2">
              <span class="fa-light fa-lg fa-fw fa-microchip"></span>&nbsp;&nbsp;{{alert.place}}
            </p>
          </div>
          }
          <div class="mt-3">
            <p [innerHTML]="alert.body | telephonify | newLineToBreak"></p>
          </div>
          <app-mark-alarm-reason [alert]="alert"></app-mark-alarm-reason>
          <app-add-note
            [alert]="alert"
            [noteText]="alert.noteCache"
            (noteTextKeeped)="handleNoteText($event, alert.alertId)"
          ></app-add-note>
          @if (!alertIsEverwatch(alert)) {
          <div class="mt-3">
            @if (alert.baseMISDN) {
            <button
              class="btn btn-primary alertCardButton mb-3"
              data-testid="call-patient-link"
              (click)="callPatient(alert.baseMISDN, alert.alertId)"
            >
              <span class="fa-light fa-fw fa-phone"></span>
              &nbsp;{{'CALL_PATIENT' |translate}}
            </button>
            }
          </div>
          }
          <div class="mt-2 d-flex">
            <button
              class="btn btn-outline-primary ml-1 mr-5 w-50"
              data-testid="complete-alert-button"
              (click)="confirmCompleteAlert(alert)"
              [disabled]="!(fireAlreadyAddedPipe | async | alreadyAdded : alert.alertId)"
            >
              <span class="fa-light fa-fw fa-box-archive"></span>
              &nbsp;&nbsp;{{'COMPLETE_ALERT' |translate}}
            </button>
            <!-- to enable "SEND_TO_APP" btn the pipe #alreadyAdded checks if the alert is in the list of alerts with attached alarms -->
            <!-- pipe triggers every time the length of the array of tasks with added alarms changes -->
            <button
              class="btn mr-1 ml-5 w-50 confirmBtn"
              (click)="confirmSendToApp(alert)"
              [disabled]="alert.transitional || !(fireAlreadyAddedPipe | async | alreadyAdded : alert.alertId)"
            >
              <span class="fa-light fa-fw fa-mobile"></span>&nbsp;&nbsp;
              {{'SEND_TO_APP' | translate }}
            </button>
          </div>
          @if (!(fireAlreadyAddedPipe | async | alreadyAdded : alert.alertId)) {
          <div style="height: 1rem;">
            <span class="validationNotice float-right mt-2">{{'CHOOSE_ONE_ALARM_REASON' | translate}}</span>
          </div>
          } @else if (appRecipientsMissing(alert)) {
          <div style="height: 1rem;">
            <span class="validationNotice float-right mt-2" data-testid="app-users-notice">
              {{'NO_EMA_USERS_CONFIGURED' | translate}}
            </span>
          </div>
          } @else if (lastAppUserSeen(alert); as lastSeen) {
          <div style="height: 1rem;">
            <span class="validationNotice float-right mt-2" data-testid="app-users-notice">
              {{'LAST_EMA_USER_SEEN' | translate : { time: (lastSeen | calculateAlertTime) } }}
            </span>
          </div>
          } @else if (availableAppRecipientCount(alert); as available) {
          <div style="height: 1rem;">
            <span class="availabilityNotice float-right mt-2" data-testid="app-users-notice">
              {{'EMA_USERS_AVAILABLE_COUNT' | translate : { count: available } }}
            </span>
          </div>
          } @else if (noAppUsersAvailable(alert)) {
          <div style="height: 1rem;">
            <span class="validationNotice float-right mt-2" data-testid="app-users-notice">
              {{'NO_EMA_USERS_AVAILABLE' | translate}}
            </span>
          </div>
          } @else if (appAvailabilityUnknown) {
          <div style="height: 1rem;">
            <span class="availabilityNotice float-right mt-2" data-testid="app-users-notice">
              {{'EMA_STATUS_UNKNOWN' | translate}}
            </span>
          </div>
          }
          <hr />
          <div>
            @if (alert.customerName) {
            <p class="mt-2">
              <span
                class="fa-light fa-fw fa-building"></span>&nbsp;&nbsp;{{alert.customerName}},&nbsp;{{alert.locationName}}
            </p>
            }
            <div class="d-flex mt-2 justify-content-end">
              <app-phonebook-button
                [customerId]="alert.customerId"
                [serverId]="alert.alertId"
              ></app-phonebook-button>
            </div>
            <!--Vega position information-->
            @if (alert.deviceType === '06-1') {
            <div class="pl-2 mt-4">
              <strong>{{ "Vega " + ("LOCATION_INFO" | translate)}}</strong>
              <hr class="mt-1 mb-3" />
              <p class="m-0 mt-2">
                <strong>X</strong>: {{ alert.positionLatitude }}&deg;
                <strong class="ml-3">Y</strong>: {{ alert.positionLongitude }}&deg;&nbsp;&nbsp;
                @if (alert.positionLink) {
                <a
                  [href]="alert.positionLink"
                  target="_blank"
                >
                  {{
                  "LOCATION_ON_MAP" | translate
                  }}
                </a>
                }
              </p>
              @if (alert.positionLink) {
              <iframe
                [src]="alert.positionLink | safe"
                allowfullscreen="1"
                title="Vega Position"
                style="height: 14vw;"
              ></iframe>
              }
            </div>
            }
          </div>
        </div>
      </div>
      }
    </div>
    }
    @if (showTeamAlerts) {
    <div>
      <div class="card-header card-header-dark">{{'ALERTS_TO_OTHERS' |translate}} ({{teamsAlerts.length}})</div>
      <div
        class="card-body card-body-dark"
        cdkDropList
        id="startedAlertList"
        [cdkDropListData]="alerts"
        [cdkDropListConnectedTo]="['incomingAlertList', 'forwardedAlertList']"
        (cdkDropListDropped)="crService.drop($event)"
      >
        @for (alert of teamsAlerts; track alert.alertId) {
        <div>
          <!--Alert card-->
          <div class="alertCard">
            <div class="alertCardHeader">
              <div class="row">
                <div class="col-12 clearfix">
                  <div class="float-left mr-3">
                    @if (alert.iconResponse) {
                    <i
                      class="fa-3x {{alert.iconResponse?.iconClass}}"
                      [style.color]="alert.iconResponse?.color || 'inherit'"
                    ></i>
                    }
                  </div>
                  @if (alert.increment > 0) {
                  <div
                    class="float-right cursorPointer"
                    (click)="crSync.resetAlertIncrement(alert.userId, alert.alertId)"
                    matTooltip="{{'INCREMENT_INFO' |translate}} {{'CLICK_TO_RESET' |translate}}"
                    [matTooltipPosition]="'above'"
                  >
                    <span class="badge badge-pill badge-danger">{{'+' + alert.increment}}</span>
                  </div>
                  }
                  <div>
                    <p class="alertHeader">
                      <strong>{{alert.header}} ({{alert.productId}})</strong>
                    </p>
                    <p class="alertHeader"> {{ alert | pickUpActivationName}}</p>
                    <small>{{ alert.time | calculateAlertTime}}</small>
                  </div>
                </div>
              </div>
            </div>
            <div class="alertCardBody clearfix">
              <div>
                <p>
                  <span class="fa-light fa-fw fa-user"></span>&nbsp;&nbsp;
                  {{ getTeamMemberName(alert) }}
                </p>
              </div>
              <div class="mb-3">
                <app-cr-notes-list [alert]="alert"></app-cr-notes-list>
                @if (showNoteForm) {
                <app-cr-notes-form
                  [alert]="alert"
                  [addedCameraVisitNotes]="addedCameraVisitNotes"
                  (onCloseByCancel)="hideForm()"
                >
                </app-cr-notes-form>
                }
              </div>
              <div>
                @if (alert.customerName) {
                <p class="mt-2">
                  <span
                    class="fa-light fa-fw fa-building"></span>&nbsp;&nbsp;{{alert.customerName}},&nbsp;{{alert.locationName}}
                </p>
                }
              </div>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
    }
    <!--Visit card-->
    @for (visit of visits; track visit) {
    <div>
      <span
        [ngTemplateOutlet]="visitTemplate"
        [ngTemplateOutletContext]="{ 
                        data: visit, 
                        src: ''
                    }"
      ></span>
    </div>
    }
  </div>
</div>

<ng-template
  #visitTemplate
  let-data="data"
  let-src="src"
>
  <div class="alertCard">
    <div class="row">
      <div class="col-lg-12">
        <div class="d-flex flex-wrap justify-content-between align-items-center">
          <div class="d-flex flex-column align-items-center">
            <div class="d-flex flex-row align-items-center">
              @if (data.iconResponse) {
              <i
                class="fa-3x {{data.iconResponse?.iconClass}}"
                [style.color]="data.iconResponse?.color || 'inherit'"
              ></i>
              }
              @if (!data.iconResponse) {
              <i class="fa-solid fa-3x fa-video text-primary icon-blue"></i>
              }

              <div class="ml-2">
                <p class="startedVisitHeader"><strong>{{!crService.alertIsNightowlVisit(data) ? (data.type |translate) :
                    ('TYPE_SCHEDULED_VISIT' |translate) }}</strong></p>
              </div>
              @if (data.snoozed) {
              <span class="badge badge-pill badge-primary snooze-badge">+1</span>
              }
            </div>
          </div>
          <div class="d-flex align-items-center border-left">
            <div class="mr-sm-4 my-2 pl-3">
              <p><small>{{'TIME_REMAINING' |translate}}</small></p>
              <p><strong>{{crService.getFormattedRemainingTime(calculateRemainingTime(data))}}</strong></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="clearfix">
          <p class="alertHeader"><strong>{{!crService.alertIsNightowlVisit(data) ? data.name: data.locationName}}</strong></p>
        </div>
        <div class="clearfix">
          <div>
            <p class="mt-2">
              <span class="fa-light fa-lg fa-fw fa-building"></span>&nbsp;&nbsp;{{!crService.alertIsNightowlVisit(data) ?
              data.companyName : data.customerName}}
            </p>
          </div>
          <div>
            <p class="mt-2">
              <span class="fa-light fa-lg fa-fw fa-microchip"></span>&nbsp;&nbsp;{{!crService.alertIsNightowlVisit(data)
              ?data.locationName : data.place}}
            </p>
          </div>
          @if (!crService.alertIsNightowlVisit(data) && data.address) {
          <div>
            <p class="mt-2">
              <span class="fa-light fa-lg fa-fw fa-location-dot">
              </span>&nbsp;&nbsp;{{getAddressString(data)}}
            </p>
          </div>
          }
        </div>
        <div class="mt-3">
          @if (crService.alertIsNightowlVisit(data)) {
          <div
            style="position:relative;"
            (mouseenter)="activateIframeClick(data.alertId || data.id)"
          >
            <iframe
              allowfullscreen
              [src]="src | safe"
              [style.pointer-events]="iFrameClicked === (data.alertId || data.id) ? 'auto' : 'none'"
              class="started"
              title="Camera visit"
              allow="autoplay; microphone; fullscreen"
            ></iframe>
            <div
              style="position:absolute;top:0;left:0;width:100%;height:100%;z-index:10;"
              [ngStyle]="{'height': iFrameClicked === (data.alertId || data.id) ? '1%' : '100%'}"
              [style.pointer-events]="iFrameClicked === (data.alertId || data.id) ? 'none' : 'auto'"
              (click)="activateIframeClick(data.alertId || data.id)"
            ></div>
          </div>
          }
          @for (camera of data.cameras; track trackByDeviceId($index, camera)) {
          <div>
            @if (!crService.alertIsNightowlVisit(data)) {
            <div
              class="iframe-container"
              [ngStyle]="{'height': getHeightInVw(camera.deviceId)}"
              (mouseenter)="activateIframeClick(camera.deviceId)"
            >
              @if (iFrameClicked !== camera.deviceId) {
              <div
                class="iframe-overlay"
                role="button"
                tabindex="0"
                aria-label="Activate camera video"
                (click)="activateIframeClick(camera.deviceId)"
                (keydown.enter)="activateIframeClick(camera.deviceId)"
                (keydown.space)="$event.preventDefault(); activateIframeClick(camera.deviceId)"
              >
              </div>
              }
              <iframe
                allowfullscreen
                [src]="camera.videoUrl | safe"
                [ngStyle]="{'height': getHeightInVw(camera.deviceId)}"
                [style.pointer-events]="iFrameClicked === camera.deviceId ? 'auto' : 'none'"
                title="Camera visit"
              >
              </iframe>
            </div>
            }
          </div>
          }
          @if (data.previousVisitTimeUtc) {
          <div class="small-center-text">
            {{previousTime(data.previousVisitTimeUtc)}}
          </div>
          }
          @if (data.snoozable && !data.snoozed) {
          <button
            class="btn btn-light"
            (click)="snoozeVisit(data)"
            id="snoozer"
          > {{'SNOOZE_VISIT_FOR_15_MIN' | translate}}
          </button>
          }
          @if (data.origonGsmNumber) {
          <button
            class="btn btn-primary alertCardButton mb-3"
            (click)="callPatient(data.origonGsmNumber, data.id)"
          >
            <span class="fa-light fa-fw fa-phone"></span>
            &nbsp;{{'CALL_PATIENT' |translate}}
          </button>
          }
        </div>
        <div class="d-flex justify-content-between">
          <button
            class="startedVisitOk p-3 flex-fill mr-2 rounded text-center cursorPointer"
            (click)="crService.alertIsNightowlVisit(data) ? completeAlert(data) : completeStartedVisit(data)"
          >
            <span class="fa-solid fa-check"></span>
            {{'EVERYTHING_OK' |translate}}
          </button>
          <div
            class="startedVisitEMA p-3 flex-fill ml-2 rounded text-center cursorPointer"
            role="button"
            tabindex="0"
            (click)="sendVisitToApp(data)"
            (keydown.enter)="sendVisitToApp(data)"
            (keydown.space)="$event.preventDefault(); sendVisitToApp(data)"
          >
            <span class="fa-solid fa-arrow-right"></span> {{'SEND_TO_APP' |translate}}
          </div>
        </div>
        <div class="mt-2">
          <p
            class="cursorPointerHover mt-2"
            (click)="crService.alertIsNightowlVisit(data) ? cancelReservation(data) : crService.cancelStartedVisit(data)"
          >
            <span class="fa-light fa-fw fa-reply"></span>&nbsp;&nbsp;
            {{ 'CANCEL_RESERVATION' |translate }}
          </p>
        </div>
      </div>
    </div>
  </div>
</ng-template>